module.exports = __webpack_public_path__ + "img/7ef65157d506edf0dedd67802b0ae6ce.png";